import Layout from '@/layout'

const route = {
  path: '/avataracquisition',
  component: Layout,
  // redirect: '/avataracquisition/index',
  alwaysShow: true, // will always show the root menu
  name: 'avataracquisition',
  meta: {
    title: '私域',
    icon: 'diy-SiYu',
    roles: [
      'siyu'
    ]
  },
  children: [
    // 头像配置信息
    {
      path: '/tencentAdvertising/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '头像配置信息',
        roles: [
          'headImg'
        ]
      },
      children: [
        {
          path: '/bitsetting/index',
          component: () => import('@/views/bitsetting/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: 'biz设置',
            // icon: 'component',
            roles: [
              'weibo.avatarConfig.loginData'
            ]
          }
        },
        {
          path: '/relationaccount/index',
          component: () => import('@/views/relationaccount/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: '关联公众号',
            // icon: 'component',
            roles: [
              'weibo.avatarConfig.numberInfoData'
            ]
          }
        }
      ]
    },
    // 排行榜
    {
      path: '/ranksing/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '排行榜',
        roles: [
          'ranking'
        ]
      },
      children: [
        {
          path: '/rankinglist/index',
          component: () => import('@/views/rankinglist/index.vue'),
          name: 'rankinglist',
          meta: {
            title: '排行榜',
            // icon: 'component',
            roles: [
              'activity.Atlas.rankingRecords'
            ]
          }
        },
        {
          path: '/atlaslist/index',
          component: () => import('@/views/atlaslist/index.vue'),
          name: 'atlaslist',
          meta: {
            title: '图集',
            // icon: 'component',
            roles: [
              'activity.Atlas.atlasList'
            ]
          }
        },
        {
          path: '/addsubset/index',
          component: () => import('@/views/addsubset/index.vue'),
          name: 'addsubset',
          meta: {
            title: '图集子集',
            icon: 'component',
            roles: [
              'activity.Atlas.atlasList'
            ]
          },
          hidden: true
        }
      ]
    },
    {
      path: '/cashback/index',
      component: () => import('@/views/cashback/index.vue'),
      name: 'Cashback',
      meta: {
        title: '用户手动返现',
        // icon: 'component',
        roles: [
          'user.userCachback.list'
        ]
      }
    },
    {
      path: '/privatedomainsales/index',
      component: () => import('@/views/privatedomainsales/index.vue'),
      name: 'Privatedomainsales',
      meta: {
        title: '私域销售列表',
        // icon: 'component',
        roles: [
          'user.saler.list'
        ]
      }
    },
    {
      path: '/userList/index',
      component: () => import('@/views/userList/index.vue'),
      name: 'UserList',
      meta: {
        title: '私域用户列表',
        // icon: 'component',
        roles: [
          'user.userCachback.list'
        ]
      }
    }
  ]

}

export default route
